import { Box, Text } from '@stitch-fix/mode-react';
export const HighValueReferralsPromoCard = () => <Box data-testid="high-value-referrals-promo-card" bgColor="mint-60" px={1.5} py={1} mt={1} style={{
  borderRadius: '8px'
}}>
    <Box style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }}>
      <Text setting="eyebrow-small" color="blue-45" align="left">
        SHARE VISION IMAGES WITH FRIENDS
      </Text>
      <Text setting="title-medium" color="blue-45" align="left">
        Earn $50 for each referral—friends get $25
      </Text>
    </Box>
  </Box>;